export default __webpack_public_path__ + "static/media/contact.d8fc1313.jpg";